/* eslint-disable no-plusplus,import/no-named-as-default */
import axios from 'axios';
import _ from 'lodash';
import store from './store';
import { SHOW_ERRORS } from './redux/actions/types/messageTypes';
import { API_URL, BASE_URL } from './constants';
import { getAuthUser, unauth } from './redux/actions/authActions';
import { UNAUTH_USER } from './redux/actions/types/authTypes';
import { showToast, unauthToast } from './redux/actions/toastrActions';


const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
    scope: '',
    grant_type: '',
  },
});

const isAbsoluteURLRegex = /^(?:\w+:)\/\//;
api.interceptors.request.use((config) => {

  const newConfig = config;

  if (!isAbsoluteURLRegex.test(config.url)) newConfig.url = API_URL + config.url;


  const user = getAuthUser();
  if (user) newConfig.headers.Authorization = `Bearer ${user.access_token}`;


  return newConfig;

});

let maxAttempts401 = 3;
api.interceptors.response.use((response) => {
  return response;
},
  (error) => {

    const user = getAuthUser();

    /* if (!user && error && error.response && error.response.status === 401) {

      window.location.href = `${BASE_URL}login`;
      maxAttempts401--;
      return Promise.reject(null);

    } else */if (error && error.response && error.response.status === 401 && user && maxAttempts401 >= 0) {

      maxAttempts401--;
      if (maxAttempts401 === 0)
        unauthToast('error', 'Sessão Expirada', 'Toque para efetuar o login novamente')
      return api(error.config);

    } else if (error && error.response && error.response.status === 400) {

      try {

        let errors = [];
        Object.keys(error.response.data).forEach(errKey => errors.push({ key: errKey, value: error.response.data[errKey][0] }));

        // A aplicação quebrou em algum ponto, não sei se back ou front
        // então pra não correr o risco vamos identificar se for gerada uma
        // array fora do padrao e arrumar isso
        const _errors = _.find(errors, { key: 'errors' });
        if (_errors && _.isObject(_errors.value)) errors = [_errors.value];


        store.dispatch({
          type: SHOW_ERRORS,
          result: errors,
        });

      } catch (e) {

      }

      return Promise.reject(null);

    } else if (error && error.response && error.response.status === 500) {

      store.dispatch({
        type: SHOW_ERRORS,
        result: [{
          key: 'SERVIDOR',
          value: 'Ocorreu um erro não identificado no servidor. Por favor, contate o suporte.',
        }],
      });

    }

    maxAttempts401 = 3;


    return Promise.reject(error);


  });

const mergeParams = params => params;

const wrapParams = (params) => {

  let response = { RequestWrapper: {} };
  response.RequestWrapper = params;
  return response;

};

export {
  api,
  mergeParams,
  wrapParams,
};

export default api;



// WEBPACK FOOTER //
// ./src/api.js